export const SITE_FOOTER_LINK_CATEGORIES_GRID_NAME = 'SiteFooterLinkCategoriesGrid';
export const SITE_FOOTER_LINKS_GRID_NAME = 'SiteFooterLinksGrid';

export const MODERATE_STATUS__APPROVED = 'APPROVED';
export const MODERATE_STATUS__PENDING = 'PENDING';
export const MODERATE_STATUS__CANCELED = 'CANCELED';
export const MODERATE_STATUS__DELETED = 'DELETED';

export const moderateStatuses = [
  MODERATE_STATUS__APPROVED,
  MODERATE_STATUS__PENDING,
  MODERATE_STATUS__CANCELED,
  MODERATE_STATUS__DELETED,
];

export const moderateStatusLangKeys = {
  [MODERATE_STATUS__APPROVED]: 'msg.approved',
  [MODERATE_STATUS__PENDING]: 'msg.pending',
  [MODERATE_STATUS__CANCELED]: 'msg.canceled',
  [MODERATE_STATUS__DELETED]: 'msg.deleted',
};

export const translationMaxSize = 255;
